import { useEffect } from "react";
import { DetailedError, useAuthStore } from "@content-buddy/shared";
import { FallbackProps } from "react-error-boundary";

import { FetchError } from "./rpc/utils";

// Shared by the pre-Mantine bootstrap boundary (App.tsx) and the
// authenticated tree (MantineRoot.tsx). Must not import "@mantine/core" or
// "@mantine/notifications" — App.tsx uses it before it has decided whether
// to fetch the Mantine chunk at all.
export default function AuthErrorBoundary({ error }: FallbackProps) {
  const { clearTokens } = useAuthStore((s) => s);

  useEffect(() => {
    if (error instanceof FetchError && error.code === 401) {
      clearTokens();
    } else if (error instanceof DetailedError && error.statusCode === 401) {
      // nothing
    } else {
      // Take this to the error boundary
      throw error;
    }
  }, [error, clearTokens]);

  return null;
}
